import { inject, Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {UrlEnum} from "../types/url-enum";

@Injectable({ providedIn: 'root' })
export class UrlService {
    public getUrl(key:UrlEnum) : string {
        return environment.backEndBaseUrl+key;
    }
}
